/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {Component, ElementRef, EventEmitter, Input, Output, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {StatefulComponent} from '../stateful/stateful.component';
import {FlyingMenuModel} from './models/flying-menu.model';

@Component({
    selector: 'app-flying-menu',
    templateUrl: './flying-menu.component.html',
    styleUrls: ['./flying-menu.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class FlyingMenuComponent extends StatefulComponent<FlyingMenuModel> {
    @Input() isDisable: boolean;
    @Output() readonly close = new EventEmitter<boolean[]>();
    @ViewChild('flyingMenuButton', {read: ElementRef}) private flyingMenuButton: ElementRef;


    constructor(private elementRef: ElementRef) {
        super();

        this.elementRef.nativeElement.setAttribute('tabindex', '-1');
        this.elementRef.nativeElement.addEventListener('focusout', this.lostFocus);
    }

    /**
     * Returns if flying menu button is disabled
     */
    get buttonIsDisabled(): string {
        return this.isDisable ? 'disabled' : null;
    }

    /**
     * Returns the global CSS class for the toggle button
     */
    get toggleButtonClass(): string {
        let base = 'flying-menu-toggle-button';
        if (this.state.isOpen) {
            base = base + ` active`;
        }
        return base;
    }

    /**
     * Returns the arrow CSS class for the toggle button
     */
    get toggleButtonArrowClass(): string {
        const base = 'toggle-button-arrow';
        return `${base} ${this.state.isOpen ? 'iwp-icon-gen_arrow_down active' : 'iwp-icon-gen_arrow_right'}`;
    }

    /**
     * Event handler for when the component has gotten focus.
     */
    gotFocus = (): void => {
        this.storeState({isOpen: true});
    };

    /**
     * Event handler for when the component has lost focus.
     */
    lostFocus = (): void => {
        this.storeState({isOpen: false});
    };

    /**
     * Event handler for when the click label menu
     */
    openFlyingMenu = (): void => {
        if (!this.isDisable) {
            this.storeState({isOpen: !this.state.isOpen});
        }
    };
}
